import { Box, Heading, SimpleGrid, GridItem } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import { WHY_ONEMIND_CONSTANTS } from "./constants";
import { AdvantageCard } from "@/views/openStackCloud/components/advantages/card";
import bgImage from "public/openStack/diffrenceBG.png";

const WhyOnemindComponent = () => {
  return (
    <Box backgroundImage={bgImage.src} backgroundSize="cover" pb={20}>
      <PageLayout marginTop={0}>
        <Box>
          <Heading
            as="h2"
            fontWeight={"400"}
            textAlign={"center"}
            fontSize={"40px"}
            color={"white"}
            my={12}
          >
            Why OneMind + Zadara?
          </Heading>
          <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={12}>
            {WHY_ONEMIND_CONSTANTS.map((item, index) => (
              <GridItem
                key={index}
                colSpan={index === 2 ? { base: 1, sm: 2, md: 2 } : 1} // Third card spans 2 columns
              >
                <AdvantageCard
                  text={item.text}
                  image={item.image}
                  title={item.title}
                  textColor={"white"}
                  headingColor={"white"}
                />
              </GridItem>
            ))}
          </SimpleGrid>
        </Box>
      </PageLayout>
    </Box>
  );
};

export default WhyOnemindComponent;
